// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var CustomFieldsSettingsController = function ($scope, CustomFieldSettings, $rootScope, gettextCatalog, gettext,
                                               Features) {
    
    $scope.componentSubscriptionLink = 'https://help.frisbii.com/frisbii-transform/docs/how-do-i-book-a-component-for-a-customer';
    $scope.meteredUsageLink = 'https://help.frisbii.com/frisbii-transform/docs/how-can-i-record-metered-component-usage-for-a-customer';
    $scope.discountSubscriptionLink = 'https://help.frisbii.com/frisbii-transform/docs/how-can-i-subsequently-book-a-discount-for-a-customer';
    
    var fieldDefinitions = [
        { Type: 'Customer', Title: 'Customer', Note: '', DocLink: '', ShowSelfService: true, ShowPortal: true, ShowReport: true, ShowUIReadWrite: true},
        { Type: 'Product', Title: 'Product', Note: '', DocLink: '', ShowSelfService: false, ShowPortal: false, ShowReport: false, ShowUIReadWrite: true },
        { Type: 'Contract', Title: 'Contract', Note: '', DocLink: '', ShowSelfService: true, ShowPortal: true, ShowReport: true, ShowUIReadWrite: true },
        { Type: 'Order', Title: 'Order', Note: '', DocLink: '', ShowSelfService: true, ShowPortal: false, ShowReport: true, ShowUIReadWrite: false },
        { Type: 'ComponentSubscription', Title: 'Component Subscription', Note: 'Component Subscription is a component added into contract.', DocLink: $scope.componentSubscriptionLink, ShowSelfService: true, ShowPortal: true, ShowReport: true, ShowUIReadWrite: false },
        { Type: 'MeteredUsage', Title: 'Metered Usage', Note: 'Metered Usage is a component added to contract.', DocLink: $scope.meteredUsageLink, ShowSelfService: true, ShowPortal: true, ShowReport: false, ShowUIReadWrite: false },
        { Type: 'DiscountSubscription', Title: 'Discount Subscription', Note: 'Discount Subscription is a discount added to contract.', DocLink: $scope.discountSubscriptionLink, ShowSelfService: true, ShowPortal: true, ShowReport: false, ShowUIReadWrite: false },
    ];

    const SEARCHABLE_CUSTOM_FIELDS_TYPES = Object.freeze(['Customer', 'Product', 'Contract', 'ComponentSubscription', 'MeteredUsage', 'DiscountSubscription']);

    $scope.canBeSearched = function(settings) {
        return SEARCHABLE_CUSTOM_FIELDS_TYPES.includes(settings.Definition.Type);
    }

    // can be handle by 1 query and filter on client side
    $scope.allSettings = [];
    for (let i = 0; i < fieldDefinitions.length; i++) {
        var fieldDefinition = fieldDefinitions[i];
        $scope.allSettings.push({
            Definition: fieldDefinition,
            Data: CustomFieldSettings.get({ customFieldType: fieldDefinition.Type }, function (data) {
                setSearchableIndicator(data);
            })
        });
    }

    $scope.features = Features.features;

    $scope.addField = function (settings) {
        settings.Data.CustomFieldDescriptors.push({ Key: '', SelfServiceSignup: 'None', SelfServiceUpdate: 'None', EditInUI: 'None', IsNewCustomField:true });
    };

    $scope.deleteField = function (settings, index) {
        settings.Data.CustomFieldDescriptors.splice(index, 1);
    };

    $scope.save = function (settings) {
        let sorted_arr = settings.Data.CustomFieldDescriptors.map(function (a) { return a.Key; }).slice().sort();
        let duplicatedApiNames = [];
        for (let i = 0; i < sorted_arr.length - 1; i++) {
            if (sorted_arr[i + 1] === sorted_arr[i])
                duplicatedApiNames.push(sorted_arr[i]);
        }
        if (duplicatedApiNames.length > 0)
            $rootScope.notify("error", gettextCatalog.getString(gettext("Duplicate API names")) + ": " + duplicatedApiNames);
        else {
            settings.Data.CustomFieldDescriptors.forEach(function (field) {
                field.IndexType = field._searchable ? 'CaseInsensitive' : 'None';
                delete field._searchable;
            });
            settings.Data.$update({}, function (data) {
                $scope.notifySuccess();
                setSearchableIndicator(data);
            });
        }
    };
    
    $scope.SearchableFieldTooltipText = gettextCatalog.getString(gettext("Please activate this checkbox only for custom fields, that require a search functionality. Once a field is newly marked as searchable, it may take some time until the search returns the expected results."));

    function setSearchableIndicator(settings) {
        settings.CustomFieldDescriptors.forEach(function (field) {
            field._searchable = field.IndexType === 'CaseInsensitive';
        });
    }
};
CustomFieldsSettingsController.$inject = ['$scope', 'CustomFieldSettings', '$rootScope', 'gettextCatalog', 'gettext',
    'Features'];
